export const userExistsError = (errorMessage: string) =>
  ["USER_EXISTS", "has already been taken"].includes(errorMessage);
